import kamala from '../../kamala'
import Ripple from './Ripple'
import Wave from './Wave'

Ripple.install = function (Vue) {
  kamala(Vue)
  Vue.component(Ripple.name, Ripple)
  Vue.component(Wave.name, Wave)
}

export {
  Ripple,
}

export default Ripple
